import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';
import {RoundNameConstants} from '../../round-name-constants';
import {Subject} from 'rxjs';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';

@Component({
  selector: 'app-round-two-reports',
  templateUrl: './round-two-reports.component.html',
  styleUrls: ['./round-two-reports.component.css']
})
export class RoundTwoReportsComponent implements OnInit {

  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  filter_id;
  title;
  token;
  students: Student[];
  rounds = [];
  outgoingRoundId = '0';
  outgoingTermId = '0';
  downloadRoundTwoAllotmentExcel = AppSettings.DOWNLOAD_ROUND_TWO_ALLOTMENT;
  selectUndefinedOptionValue = '0';
  roundTwoAllotment = [];
  errorMessage;

  constructor(private route: ActivatedRoute,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService) { }

  getAllRounds(): void {
    this.dmService.getAll(Constants.ROUND_SETTINGS)
        .subscribe(
            response => {
              if (response.status === 'success') {
                // this.rounds = response.data;
                for (let i = 0; i < response.data.length; i++) {
                  if (response.data[i].outgoing_round_name_id === parseInt(RoundNameConstants.PRACTICE_BIDDING_ROUND, 10)) {
                    this.rounds.push(response.data[i]);
                  }
                }
                if (this.rounds.length > 0) {
                  this.outgoingRoundId = this.rounds[0].outgoing_round_id;
                  this.outgoingTermId = this.rounds[0].outgoing_term_id;
                }
                if (this.filter_id === 1) {
                  this.getRoundTwoAllotmentDetails();
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getRoundTwoAllotmentDetails(): void {
    this.dmService.getOne(Constants.ROUND_TWO_ALLOTMENT, this.outgoingTermId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.roundTwoAllotment = response.data;
                if (this.roundTwoAllotment.length === 0) {
                  this.errorMessage = 'There is no data available for Round Two Allotment';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  termChange() {
    if (this.filter_id === 1) {
      this.getRoundTwoAllotmentDetails();
    }
  }

  ngOnInit() {
    this.getAllRounds();
    this.token = '?token=' + this.authenticationService.getToken();
    this.route
        .params
        .subscribe(params => {
          this.filter_id = parseInt(params['id'], 10);
        });
    if (this.filter_id === 1) {
      this.title = 'Round Two Allotment';
    }
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
